export default __webpack_public_path__ + "assets/dust.d93c8671.svg";